import React from 'react';
var YoutubeComponent = function (_a) {
    var src = _a.src, width = _a.width, height = _a.height, _b = _a.title, title = _b === void 0 ? 'youtube' : _b, onError = _a.onError;
    return (React.createElement("iframe", { width: width, height: height, src: src, frameBorder: "0", title: title, allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", onError: onError }));
};
export default YoutubeComponent;



//////////////////
// WEBPACK FOOTER
// ./src/detail/comments/youtube.tsx
// module id = 97
// module chunks = 0